import React from "react";
import "./Home.css";

const Home = () => {
  return (
    <div className="home-container">
      <div className="content">
        <h1>I'm George</h1>
        <h2>Welcome to My Website</h2>
        <p>
          I'm a software engineering student from Victoria, BC. I'm passionate 
          about front-end development and crafting intuitive, user-friendly 
          UI/UX experiences.
        </p>
      </div>
    </div>
  );
};

export default Home;